import _slicedToArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * Helper utility functions for QueryBuilder.
 */
export var QueryBuilderUtils = /*#__PURE__*/function () {
  function QueryBuilderUtils() {
    _classCallCheck(this, QueryBuilderUtils);
  }
  _createClass(QueryBuilderUtils, null, [{
    key: "isAliasProperty",
    value:
    /**
     * Checks if given value is a string representation of alias property,
     * e.g. "post.category" or "post.id".
     */
    function isAliasProperty(str) {
      // alias property must be a string and must have a dot separator
      if (typeof str !== "string" || str.indexOf(".") === -1) return false;
      // extra alias and its property relation
      var _str$split = str.split("."),
        _str$split2 = _slicedToArray(_str$split, 2),
        aliasName = _str$split2[0],
        propertyName = _str$split2[1]; // todo: what about relations in embedded?
      if (!aliasName || !propertyName) return false;
      // alias and property must be represented in a special format
      // const aliasNameRegexp = /^[a-zA-Z0-9_-]+$/;
      // if (!aliasNameRegexp.test(aliasName) || !aliasNameRegexp.test(propertyName))
      //     return false;
      // make sure string is not a subquery
      if (str.indexOf("(") !== -1 || str.indexOf(")") !== -1) return false;
      return true;
    }
  }]);
  return QueryBuilderUtils;
}();